import { TableColumn, TableColumnType } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';

export class TableColumnData {
  /* Default table column configurations */
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`:table header:User`,
      class: 'w-[15%] min-w-[5rem] !flex-grow-0',
      innerClass: '!mx-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
      disableClick: true,
    },
    {
      sequence: 2,
      columnDef: 'createdAt',
      header: $localize`:table header:Downloaded at`,
      type: TableColumnType.date,
      class: 'w-[15%] min-w-[10rem] !flex-grow-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 3,
      columnDef: 'variant',
      header: $localize`:table header:Variant`,
      class: 'w-[15%] w-[25%] min-w-[13rem] !flex-grow-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 4,
      columnDef: 'version',
      header: $localize`:table header:Version`,
      class: 'w-[10%] min-w-[7rem] !flex-grow-0',
      innerClass: '!mx-8',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      excludeClient: [CustomClients.SEAT],
    },
    {
      sequence: 5,
      columnDef: 'format',
      header: $localize`:table header:Format`,
      class: 'w-[15%] min-w-[10rem] !flex-grow-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 6,
      columnDef: 'module',
      header: $localize`:table header:Module`,
      class: 'w-[15%] min-w-[10rem] !flex-grow-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 7,
      columnDef: 'channel',
      header: $localize`:table header:Channel`,
      class: 'w-[15%] min-w-[5rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      excludeClient: [CustomClients.Standard, CustomClients.SEAT, CustomClients.VKB, CustomClients.LufthansaMedialounge, CustomClients.LufthansaMediacenter],
    },
    {
      sequence: 8,
      columnDef: 'licenseRegion',
      header: $localize`:table header:License region`,
      class: 'w-[15%] min-w-[5rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
      excludeClient: [CustomClients.Standard, CustomClients.SEAT, CustomClients.VKB, CustomClients.LufthansaMedialounge, CustomClients.LufthansaMediacenter],
    },
  ];
}
